import React, { useState, useEffect } from 'react';
import './inView.css';

function C2wiInView({ placementsArray = null, index = 0, handleFlag }) {
    const [activeIndex, setActiveIndex] = useState(index);


    
    /**
     * @function useEffect Hook for window resize listener
     * @author Vishal Lohbande
     *
     * Description:
     * - Registers an event listener for the window `resize` event when the component mounts.
     * - Defines a handler function `handleResize` that updates the `windowWidth` state with the latest `window.innerWidth`.
     * - Cleans up the event listener when the component unmounts to avoid memory leaks.
     *
     * Usage:
     * - Keeps the React component state synchronized with the browser window size.
     *
     * Notes:
     * - The effect runs only once on mount due to the empty dependency array `[]`.
     * - For better performance, consider throttling or debouncing the resize handler.
     * - In server-side rendering environments, verify that `window` is defined before accessing it.
     */
      const [windowWidth, setWindowWidth] = useState(window.innerWidth);
        useEffect(() => {
          const handleResize = () => {
            setWindowWidth(window.innerWidth);
          };
      
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
        }, []);



    return (
        <div className='C2wiInView_ctn'>
            <div className='C2wiInView_ctn_holder'>
            <div className='CrossIconHolder' onClick={() => handleFlag(false)}>
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6325 1.71581L16.9167 0L9.31625 7.6125L1.71581 0L0 1.71581L7.6125 9.31625L0 16.9167L1.71581 18.6325L9.31625 11.02L16.9167 18.6325L18.6325 16.9167L11.02 9.31625L18.6325 1.71581Z" fill="white"/>
                </svg>
            </div>
            { windowWidth > 620 && 
                <button 
                    onClick={() => setActiveIndex(activeIndex - 1)}
                style={{ visibility: activeIndex > 0 ? "visible" : "hidden" }}
                >
                    <svg width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.4569 3.2575L13.1581 0.960834L0.636892 13.4777C0.435058 13.6782 0.274879 13.9167 0.165575 14.1794C0.0562712 14.4421 0 14.7239 0 15.0084C0 15.293 0.0562712 15.5747 0.165575 15.8374C0.274879 16.1001 0.435058 16.3386 0.636892 16.5392L13.1581 29.0625L15.4547 26.7658L3.70273 15.0117L15.4569 3.2575Z" fill="white" />
                    </svg>
                </button>
            }

            <img src={`assets/images/placements/${placementsArray[activeIndex]}`} alt='placement-image' />
        { windowWidth > 620 &&  
            <button 
                onClick={() => setActiveIndex(activeIndex + 1)} 
                disabled={activeIndex === placementsArray.length - 1}
                style={{ visibility: activeIndex < placementsArray.length - 1 ? "visible" : "hidden" }}
            >
                <svg width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.312639 3.2575L2.61147 0.960834L15.1326 13.4777C15.3345 13.6782 15.4947 13.9167 15.604 14.1794C15.7133 14.4421 15.7695 14.7239 15.7695 15.0084C15.7695 15.293 15.7133 15.5747 15.604 15.8374C15.4947 16.1001 15.3345 16.3386 15.1326 16.5392L2.61147 29.0625L0.314805 26.7658L12.0668 15.0117L0.312639 3.2575Z" fill="white" />
                </svg>
            </button>
            }
        </div>
        { windowWidth < 620 && 
        <div className='C2wPlacemnetsCardNavgate_icon_hld'>
                <button 
                onClick={() => setActiveIndex(activeIndex - 1)}
                disabled={activeIndex === 0}
            >
                <svg width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.4569 3.2575L13.1581 0.960834L0.636892 13.4777C0.435058 13.6782 0.274879 13.9167 0.165575 14.1794C0.0562712 14.4421 0 14.7239 0 15.0084C0 15.293 0.0562712 15.5747 0.165575 15.8374C0.274879 16.1001 0.435058 16.3386 0.636892 16.5392L13.1581 29.0625L15.4547 26.7658L3.70273 15.0117L15.4569 3.2575Z" fill="white" />
                </svg>
            </button>
               <button 
                onClick={() => setActiveIndex(activeIndex + 1)} 
                disabled={activeIndex === placementsArray.length - 1}
                style={{ display : activeIndex <= placementsArray.length - 1}}
            >
                <svg width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.312639 3.2575L2.61147 0.960834L15.1326 13.4777C15.3345 13.6782 15.4947 13.9167 15.604 14.1794C15.7133 14.4421 15.7695 14.7239 15.7695 15.0084C15.7695 15.293 15.7133 15.5747 15.604 15.8374C15.4947 16.1001 15.3345 16.3386 15.1326 16.5392L2.61147 29.0625L0.314805 26.7658L12.0668 15.0117L0.312639 3.2575Z" fill="white" />
                </svg>
            </button>
        </div>
}
        </div>
    );
}

export default C2wiInView;
